import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './utils/theme';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import LoginPage      from './pages/LoginPage';
import OverviewPage   from './pages/OverviewPage';
import EnrolmentPage  from './pages/EnrolmentPage';
import MessagesPage   from './pages/MessagesPage';
import TelecomsPage   from './pages/TelecomsPage';
import EngagementPage from './pages/EngagementPage';
import NonRespondersPage   from './pages/NonRespondersPage';
import FailedMessagesPage  from './pages/FailedMessagesPage';
import ImmunizationPage    from './pages/ImmunizationPage';
import TrafficPage from './pages/TrafficPage';
import { CircularProgress, Box } from '@mui/material';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <CircularProgress color="primary" />
    </Box>
  );
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/" element={<ProtectedRoute><OverviewPage /></ProtectedRoute>} />
      <Route path="/enrolment" element={<ProtectedRoute><EnrolmentPage /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
      <Route path="/telecoms" element={<ProtectedRoute><TelecomsPage /></ProtectedRoute>} />
      <Route path="/engagement" element={<ProtectedRoute><EngagementPage /></ProtectedRoute>} />
      <Route path="/traffic" element={<ProtectedRoute><TrafficPage /></ProtectedRoute>} />
      <Route path="/non-responders" element={<ProtectedRoute><NonRespondersPage /></ProtectedRoute>} />
      <Route path="/failed-messages" element={<ProtectedRoute><FailedMessagesPage /></ProtectedRoute>} />
      <Route path="/immunization" element={<ProtectedRoute><ImmunizationPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
